import { connect } from 'react-redux'
import { settings, getAttributes, selectors } from '../../imports'
import {
    getHash,
    updateNews,
    updateCreatives,
    updateMotd,
    updateTwitch,
    updateVersions,
    updateBackground,
    updateHash,
    updateServerStatus,
} from '../../data'
import Sync from './component'

function mapStateToProps(state) {
    const attributes = getAttributes(selectors.getLocale(state))
    return {
        hash: getHash(state),
        versionRegex: attributes.versionRegex,
        settings,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateNews: (hash) => {
            dispatch(updateNews(hash))
        },
        updateCreatives: (timeStamp) => {
            dispatch(updateCreatives(timeStamp))
        },
        updateMotd: (timeStamp) => {
            dispatch(updateMotd(timeStamp))
        },
        updateTwitch: (twitch) => {
            dispatch(updateTwitch(twitch))
        },
        updateVersions: (versions) => {
            dispatch(updateVersions(versions))
        },
        updateBackground: (background) => {
            dispatch(updateBackground(background))
        },
        updateHash: (hash) => {
            dispatch(updateHash(hash))
        },
        updateServerStatus: (serverId, status, count) => {
            dispatch(updateServerStatus(serverId, status, count))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sync)



// WEBPACK FOOTER //
// ./src/features/Sync/components/Sync/index.js